export default __webpack_public_path__ + "static/media/14.94a8b7db.jpg";